<script setup>
defineProps({
  hoverable: { type: Boolean, default: true }
})
</script>

<template>
  <div class="card" :class="{ 'card--hoverable': hoverable }">
    <slot />
  </div>
</template>

<style scoped>
.card {
  position: relative;
  border-radius: var(--r-md);
  background: var(--bg-glass);
  border: 1px solid var(--ash);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  padding: var(--sp-4);
  transition: transform var(--t-base) var(--ease-cinema),
              border-color var(--t-base) var(--ease-cinema),
              background var(--t-base) var(--ease-cinema);
  overflow: hidden;
}
.card::before {
  content: "";
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--gold) 50%, transparent);
  opacity: 0.35;
  pointer-events: none;
}
.card--hoverable:hover {
  transform: translateY(-3px);
  border-color: var(--gold);
  background: var(--bg-glass-strong);
}
.card--hoverable:hover::before { opacity: 0.85; }
</style>
